import * as React from 'react';
import { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, CustomInput, InputGroup, InputGroupAddon, FormText } from 'reactstrap';
import Icon from "components/Varios/Icons.js";
import GoogleMapReact from 'google-map-react';
import { Marker } from 'google-maps-react';
import axios from "axios";
import { Link } from "react-router-dom";

const AnyReactComponent = ({ text }) => <div><Icon kind="ubicacion" fill='#FF3333' width={30} height={30} /></div>;

let mapsEndpoint = "https://maps.googleapis.com/maps/api/js?key=AIzaSyD2T67Tlkmx9ewAZ2t-JHR8rbQknquZ0gE";
let source = axios.CancelToken.source();

const style = {
    height: '500px',
    padding: '0px',
};

const mapStyles = {
    width: '100%',
    height: '100%',
};


export default class ModalMap extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            isLoading: false
        };

        this.fileRef = React.createRef();
        this.handleClick = this.handleClick.bind(this);
    }

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    };

    onClick = change => {
        this.setState(
            {
                isOpen: !this.state.isOpen,
            },
            (() => { this.props.onAcept(this.props.lat + ", " + this.props.lng, this.props.tipo) })
        );
    };

    handleClick() {
        const fileInput = this.fileRef.current;
        fileInput.click();
    }

    //componentDidMount() {
    //    this.fetchUser();
    //}


    //fetchUser = () => {
    //    setTimeout(() => {
    //        this.setState({ isLoading: true });
    //        axios
    //            .get(mapsEndpoint, {
    //                cancelToken: source.token
    //            })
    //            .then((res) => {
    //                this.setState({ isLoading: false });
    //            })
    //            .catch((e) => {
    //                console.log(e.message);
    //            });
    //    }, 2000);
    //};

    //componentWillUnmount() {
    //    if (source) {
    //        source.cancel("Landing Component got unmounted");
    //    }
    //}

    //render() {

    //    let contents = this.state.isLoading

    //        ? <p><em>Loading...</em></p>

    //        : this.renderMap();

    //    return <div>

    //        {contents}

    //    </div>;

    //}

    render() {

        return (
            <div>
                <InputGroup>
                    <Input type="text" name="coordenadas" onChange={this.props.onChangeInput} value={this.props.value} readOnly hidden />
                    <Input onClick={this.handleClick} type="text-plaintext" id="inputMap" onChange={this.props.onChangeInput} value={(this.props.value ? "Actualizar ubicación. " : "Seleccione una ubicación. ")} readOnly />
                    <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>
                        <a onClick={this.toggle} ref={this.fileRef}><Icon kind="ubicacion" fill='#FFFFFF' width={27} height={27} /></a>
                    </InputGroupAddon>
                </InputGroup>

                <Modal size="lg" isOpen={this.state.isOpen} toggle={this.toggle} >

                    <ModalBody>
                        <div style={{ height: '80vh', width: '100%' }}>
                        <GoogleMapReact
                            bootstrapURLKeys={{ key: "AIzaSyD2T67Tlkmx9ewAZ2t-JHR8rbQknquZ0gE"}}
                            center={
                                {
                                    lat: parseFloat(this.props.lat),
                                    lng: parseFloat(this.props.lng)
                                }
                                    
                            }
                            defaultZoom={18}
                            onClick={this.props.onClick}
                            tipo={this.props.tipo}
                        >
                                <AnyReactComponent
                                    lat={this.props.lat}
                                    lng={this.props.lng}
                                />
                            </GoogleMapReact>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={change => this.onClick(change)}>Aceptar</Button>{' '}
                        <Button color="primary" onClick={this.toggle}>Cancelar</Button>
                    </ModalFooter>

                </Modal>
            </div >
        );
    }

}


